import React, { Component } from 'react';
import LiveNFT from './LiveNFT.js';

class ProfileBackground extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }


  render() {
    // TODO move SUPERF3ST appearance of profile cam murdoch no show live nft server side
    return (
      <div>
        {
          this.props.creatorName == "SUPERF3ST" || this.props.creatorName == "glitch" || this.props.creatorName == "Carla the Poet"
            ?
          <div className="min-h-[120px] mt-16 sm:h-128 w-screen bg-custom-black sm:flex sm:justify-center sm:items-center flex flex-col-reverse">
            <div className="sm:flex sm:flex-col sm:mt-0 mt-8 flex flex-col-reverse">
              <div className="sm:absolute sm:z-20 sm:left-12 sm:top-80 sm:ml-0 sm:pt-0 sm:text-8xl text-2xl ml-12 flex flex-col text-white font-bold">
              </div>
              <div className="sm:absolute sm:z-20 sm:mt-20 sm:top-96 sm:left-12 sm:ml-0 ml-12 rounded-full">
                <img
                  className="mt-16 rounded-full w-16 h-16 sm:w-24 sm:h-24"
                  src={this.props.creatorImage}
                />
              </div>
            </div>
            {
              this.props.liveNFTItem != null && this.props.creatorAddress !== "0x13ef06797f095d5c62babf704d983cf1b4bde9e5"
                ?
              <LiveNFT
                liveNFTItem={this.props.liveNFTItem}
              />
                :
              null
            }
            <div
              style={{
                backgroundImage: `url(${this.props.creatorBackgroundBlurredImage})`,
              }}
              className="w-screen min-h-[120px] sm:h-128"
            >
            </div>
          </div>
            :
          <div className="min-h-[120px] mt-16 sm:h-128 w-screen bg-custom-black sm:flex sm:justify-center sm:items-center flex flex-col-reverse">
            <div className="sm:flex sm:flex-col sm:mt-0 mt-8 flex flex-col-reverse">
              <div className="sm:absolute sm:z-20 sm:left-12 sm:top-80 sm:ml-0 sm:pt-0 sm:text-8xl text-2xl ml-12 flex flex-col text-white font-bold">
                {this.props.creatorName}
              </div>
              <div className="sm:absolute sm:z-20 sm:mt-20 sm:top-96 sm:left-12 sm:ml-0 ml-12 rounded-full">
                <img
                  className="mt-16 rounded-full w-16 h-16 sm:w-24 sm:h-24"
                  src={this.props.creatorImage}
                />
              </div>
            </div>
            {
              this.props.liveNFTItem != null && this.props.creatorAddress !== "0x13ef06797f095d5c62babf704d983cf1b4bde9e5"
                ?
              <LiveNFT
                liveNFTItem={this.props.liveNFTItem}
              />
                :
              null
            }
            <div
              style={{
                backgroundImage: `url(${this.props.creatorBackgroundBlurredImage})`,
              }}
              className="w-screen min-h-[120px] sm:h-128"
              id="blurred"
            >
            </div>
          </div>
        }
      </div>
    );
  }
}

export default ProfileBackground;
